import { DOCUMENT } from '@angular/common';
import { Component, Inject, OnDestroy, OnInit, Renderer2 } from '@angular/core';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-hubspot-page-visit-script',
  templateUrl: './hubspot-page-visit-script.component.html',
  styleUrls: ['./hubspot-page-visit-script.component.scss']
})
export class HubspotPageVisitScriptComponent implements OnInit {
  private gtmId = environment.gtmId;

  constructor(
    private renderer: Renderer2,
    @Inject(DOCUMENT) private document: Document
  ) { }

  ngOnInit(): void {
    if (!this.document.getElementById('gtm-script')) {
      this.insertGtmScript();
    }

    if (!this.document.getElementById('gtm-noscript')) {
      this.insertGtmNoScript();
    }
  }

  private insertGtmScript(): void {
    const script = this.renderer.createElement('script');
    script.id = 'gtm-script';
    script.text = `
      (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
      new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
      j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
      'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
      })(window,document,'script','dataLayer','${this.gtmId}');
    `;
    this.renderer.appendChild(this.document.head, script);
  }

  private insertGtmNoScript(): void {
    const noscript = this.renderer.createElement('noscript');
    noscript.id = 'gtm-noscript';
    noscript.innerHTML = `
      <iframe src="https://www.googletagmanager.com/ns.html?id=${this.gtmId}"
      height="0" width="0" style="display:none;visibility:hidden"></iframe>
    `;
    this.renderer.appendChild(this.document.body, noscript);
  }
}